// extracted by mini-css-extract-plugin
export default {"myInput":"styles_myInput__VpKju"};